import { render, staticRenderFns } from "./DependentsForContent.vue?vue&type=template&id=546dc250&scoped=true"
import script from "./DependentsForContent.vue?vue&type=script&lang=js"
export * from "./DependentsForContent.vue?vue&type=script&lang=js"
import style0 from "./DependentsForContent.vue?vue&type=style&index=0&id=546dc250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546dc250",
  null
  
)

export default component.exports